import type { UrgencySignalsProps } from '@eventbrite/urgency-signals';
import {
    OnlyWhenUrgencySignalsEnabled,
    UrgencyMessages,
    UrgencySignalsProvider,
} from '@eventbrite/urgency-signals';
import React, { FunctionComponent } from 'react';

import classNames from 'classnames';

import {
    DEFAULT_STYLES,
    getStyles,
    REBRANDING_STYLES,
} from '../../utils/rebrand';

import defaultStyles from './UrgencySignalsNode.module.scss';
import rebrandStyles from './UrgencySignalsNode.rebranding.module.scss';

const stylesModules = {
    [DEFAULT_STYLES]: defaultStyles,
    [REBRANDING_STYLES]: rebrandStyles,
};

export const UrgencySignalsNode: FunctionComponent<{
    urgencySignals: UrgencySignalsProps;
    floating?: boolean;
    isAppRebrandActive?: boolean;
}> = ({ urgencySignals, floating, isAppRebrandActive }) => {
    const theme = getStyles(!!isAppRebrandActive);
    const styles = stylesModules[theme];

    return (
        <UrgencySignalsProvider urgencySignals={urgencySignals}>
            <OnlyWhenUrgencySignalsEnabled>
                <div
                    className={classNames(
                        { [styles.floating]: floating },
                        styles.wrapper,
                    )}
                    data-testid="checkout-urgency-signal"
                >
                    <UrgencyMessages
                        className={styles.urgencyMessages}
                        isAppRebrandActive={isAppRebrandActive}
                    />
                </div>
            </OnlyWhenUrgencySignalsEnabled>
        </UrgencySignalsProvider>
    );
};
